export const BestandView2Headers = [
    {
        id: 1,
        title: 'Firma Kurz',
        mouseOver: '',
    },
    {
        id: 2,
        title: 'Firma',
        mouseOver: '',
    },
    {
        id: 3,
        title: 'MA',
        mouseOver: '',
    },
    {
        id: 4,
        title: 'Zust. FKB',
        mouseOver: '',
    },
    {
        id: 5,
        title: 'BD',
        mouseOver: '',
    },
    {
        id: 6,
        title: 'FD',
        mouseOver: '',
    },
    {
        id: 7,
        title: 'DGAPI KAM',
        mouseOver: '',
    },
    {
        id: 8,
        title: 'DL+Kzl vollst',
        mouseOver: 'DL+Kanzleiauftrag Prüfung vollständig',
    },
    {
        id: 9,
        title: 'Projtd vollst',
        mouseOver: 'Projektdefintion vollständig',
    },
    {
        id: 10,
        title: 'Projtd abge',
        mouseOver: 'Projektdefinition abgefragt',
    },
    {
        id: 11,
        title: 'AA FA hin',
        mouseOver: 'AnrAuskunft FA hin',
    },
    {
        id: 12,
        title: 'StSvGA erst.',
        mouseOver: 'st- sv-Gutachten erstellt',
    },
    {
        id: 13,
        title: 'ArTfGA erst.',
        mouseOver: 'arb- tarif-Gutachten erstellt',
    },
    {
        id: 14,
        title: 'ProjStart',
        mouseOver: 'ProjektStart (MA-Vortrag)',
    },
    {
        id: 15,
        title: 'MAV an FKB',
        mouseOver: 'MA-Vortrag an FKB',
    },
    {
        id: 16,
        title: 'MAB fertig',
        mouseOver: 'MAB Druckauftrag',
    },
    {
        id: 17,
        title: 'Bemerk',
        mouseOver: 'Bemerkung'
    },
]